var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeader',{attrs:{"image":_vm.RegulamentoBannerImage,"ariaLabel":"Mulher em pose de largada","minHeight":421,"title":"Regulamento"}})}
var staticRenderFns = []

export { render, staticRenderFns }